import React, {useEffect, useState} from 'react';
import {useAppBridge} from '@shopify/app-bridge-react';

// ui-components
import RealPennedLetterPlain from '~/pages/plain/RealPennedLetter';

// types
import {Intent, PlainObject} from '~/types/shopify.types';

const RealPennedLetter: React.FC<React.PropsWithoutRef<any>> = () => {
  const shopify = useAppBridge();
  const [intent, setIntent] = useState<Intent | PlainObject>({});

  useEffect(() => {
    const cleanup = shopify.intents.register(setIntent);

    return () => cleanup();
  }, [shopify.intents]);

  return (
    <RealPennedLetterPlain
      intent={(intent as Intent)}
      onComplete={fields => intent.finish(fields)}/>
  );
};

export default RealPennedLetter;
